export const ANALYTICS = {
  EVENTS: {
    CLICKED_BUTTON: 'Clicked Button',
    CLICKED_MODAL: 'Clicked Modal Open',
    CLICKED_LINK: 'Clicked Link',
    VIEWED_BLOG_PAGE: 'Viewed Blog Page',
    VIEWED_COMPONENT: 'Viewed Component',
    NAV_SEARCH_PERFORMED: 'Nav Search Performed',
  },
  NAVIGATION_V2: {
    COMPONENT: 'NavigationBarV2',
    OPEN_CART: 'Open Cart',
    OPEN_SEARCH: 'Open Search',
    LINK_CLICK: 'Link Click',
    OPEN_CATEGORY: 'Open Category',
    REGISTER: 'Register Kit',
    OPEN_MOBILE_MENU: 'Open Mobile Menu',
    BACK_TO_MAIN_MENU: 'Back to Main Menu',
    PROFILE: 'Profile',
    SPOTLIGHT_CLICK: 'Spotlight Click',
    SEARCH_PERFORMED: 'Search Performed',
    LOGO_CLICK: 'Logo Click',
    MAIN_BUTTON_DRAWER_CLICK: 'Main Button Drawer Click',
    SHOP_ALL_PRODUCTS: 'Shop All Products',
  },
  FOOTER_V2: {
    COMPONENT: 'FooterV2',
    LINK_CLICK: 'Link Click',
    SOCIAL_MEDIA_CLICK: 'Social Media Click',
  },
};
